import script from "./InfiniteScrollLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./InfiniteScrollLoader.vue?vue&type=script&setup=true&lang=js"

import "./InfiniteScrollLoader.vue?vue&type=style&index=0&id=929f901c&scoped=true&lang=css"

import exportComponent from "/home/tamo/projects/wedio/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-929f901c"]])

export default __exports__